/**
 * Merge e classificação de jobs de importação CSV.
 * Preferência: done/error > running/queued; progresso nunca regride.
 */

function statusRank(status) {
  if (status === 'done' || status === 'error') return 3;
  if (status === 'running') return 2;
  if (status === 'queued') return 1;
  return 0;
}

function jobTimestamp(job) {
  return Number(job?.finishedAt || job?.updatedAt || job?.startedAt || job?.createdAt || 0);
}

/**
 * Une snapshots do mesmo jobId, preferindo estado terminal e maior progresso.
 * @param {Array<object>} candidates
 * @returns {Array<object>}
 */
export function pickFreshestJobs(candidates) {
  const byId = new Map();
  for (const job of candidates || []) {
    if (!job?.jobId) continue;
    const prev = byId.get(job.jobId);
    if (!prev) {
      byId.set(job.jobId, job);
      continue;
    }

    const prevRank = statusRank(prev.status);
    const nextRank = statusRank(job.status);
    if (nextRank !== prevRank) {
      if (nextRank > prevRank) byId.set(job.jobId, job);
      continue;
    }

    const prevProcessed = Number(prev.progress?.processed || 0);
    const nextProcessed = Number(job.progress?.processed || 0);
    if (nextProcessed !== prevProcessed) {
      if (nextProcessed > prevProcessed) byId.set(job.jobId, job);
      continue;
    }

    if (jobTimestamp(job) >= jobTimestamp(prev)) {
      byId.set(job.jobId, job);
    }
  }
  return [...byId.values()];
}

/**
 * Job ainda em andamento de verdade (não 100% travado no fim).
 */
export function isJobActivelyRunning(job) {
  if (!job) return false;
  if (job.status !== 'running' && job.status !== 'queued') return false;
  const total = Number(job.progress?.total || 0);
  const processed = Number(job.progress?.processed || 0);
  const percent = Number(job.progress?.percent || 0);
  if (total > 0 && processed >= total) return false;
  if (percent >= 100 && processed > 0) return false;
  return true;
}

export function isJobFinished(job) {
  if (!job) return false;
  if (job.status === 'done' || job.status === 'error') return true;
  return !isJobActivelyRunning(job) && (job.status === 'running' || job.status === 'queued');
}
